import React from 'react';
import {
  Box, Table, TagChip, Filter, Link,
} from 'vindi-ds-components';
import useKindTagChip from '../hooks/useKindTagChip';
import useFilter from '../hooks/useFilter';

function TableCustomerList({ status, setDescription }) {
  const { listing } = useFilter({ status });
  const { isLoading, status: statusQuery, data } = listing.query;

  const columns = [
    {
      label: 'Nome',
      align: 'left',
    },
    {
      label: 'Status',
      align: 'left',
    },
  ];

  const descriptions = {
    active: 'Clientes com uma ou mais assinaturas ativas',
    inactive:
      'Clientes com assinaturas encerradas ou que nunca possuíram assinatura',
    delinquent: 'Clientes com cobranças vencidas',
    archived: '',
  };

  React.useEffect(() => {
    setDescription(descriptions[status]);
  }, [status]);

  if (isLoading || statusQuery === 'idle') {
    return null;
  }

  return (
    <Filter.FilterProvider {...listing}>
      <Table.Container>
        <Table.Head columns={columns} />
        <Table.Body>
          {data?.customers?.map((customer) => (
            <Table.Row key={customer.id}>
              <Table.Cell align='left'>
                <Link href={`customers/${customer.id}`}>{customer.name}</Link>
              </Table.Cell>
              <Table.Cell align='left'>
                {customer.status.map((tag) => {
                  const tagStatus = useKindTagChip(tag);
                  return (
                    <Box mr={1} key={`${customer.id}-${tag}`}>
                      <TagChip label={tagStatus.label} kind={tagStatus.kind} />
                    </Box>
                  );
                })}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Container>
      <Filter.Pagination />
    </Filter.FilterProvider>
  );
}

export default TableCustomerList;
